export const TornadoIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="00" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(6.000000, 13.000000)">
                    <path
                        d="M15.92 35.157h49.254c.907 0 1.642-.93 1.642-2.075 0-1.147-.735-2.076-1.642-2.076H15.921c-.907 0-1.642.93-1.642 2.076s.735 2.075 1.642 2.075zM37.81 48.994h32.836c.907 0 1.642-.93 1.642-2.076s-.735-2.075-1.642-2.075H37.81c-.907 0-1.642.929-1.642 2.075 0 1.146.736 2.076 1.642 2.076zM4.975 7.484h70.05c.906 0 1.641-.93 1.641-2.075 0-1.147-.735-2.076-1.641-2.076H4.975c-.907 0-1.642.93-1.642 2.076s.735 2.075 1.642 2.075zM4.975 21.32h60.199c.906 0 1.642-.929 1.642-2.075 0-1.146-.736-2.075-1.642-2.075h-60.2c-.906 0-1.641.929-1.641 2.075 0 1.146.735 2.076 1.642 2.076zM37.81 62.83H59.7c.907 0 1.643-.93 1.643-2.075 0-1.147-.736-2.076-1.642-2.076H37.81c-.907 0-1.642.93-1.642 2.076s.735 2.075 1.641 2.075zM32.338 76.666h10.945c.907 0 1.642-.929 1.642-2.075 0-1.146-.735-2.075-1.642-2.075H32.338c-.907 0-1.642.929-1.642 2.075 0 1.146.735 2.076 1.642 2.076z"
                        fill="#3F4447"
                    />
                </g>
            </g>
        </g>
    </svg>
);
